import { createAiChat } from '@constructor/ai-chat'
import type { AiChatApi } from '@constructor/ai-chat'
import type { FederationRoot } from '@constructor/federation/base'

export function useAiChat(federationRoot: FederationRoot) {
  const aiChatService = createAiChat({ federationRoot })
  let initPromise: Promise<AiChatApi> | undefined

  return {
    getAiChatApi,
  }

  async function getAiChatApi() {
    const chatApi = aiChatService.getChatApi()

    if (chatApi) {
      return chatApi
    }

    if (!initPromise) {
      initPromise = aiChatService.init().finally(() => (initPromise = undefined))
    }

    return initPromise
  }
}
